import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import MUISelect from '@mui/material/Select'
import PropTypes from 'prop-types'
import React from 'react'

import Box from './box'

const Select = ({ children, error, label, helperText, id, ...selectProps }) => (
  <FormControl error={error} fullWidth>
    <Box marginBottom={3}>
      <InputLabel htmlFor={id}>{label}</InputLabel>
    </Box>
    <MUISelect labelId={id} inputProps={{ id }} {...selectProps}>
      {children}
    </MUISelect>
    {helperText && <FormHelperText>{helperText}</FormHelperText>}
  </FormControl>
)

Select.propTypes = {
  children: PropTypes.node.isRequired,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  id: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
}

Select.defaultProps = {
  error: false,
  helperText: null,
}

Select.Item = MenuItem

export default Select
